import type { TourDefinition } from '../training/tours';

/**
 * Тур конструктора звітів. Ідентифікатор для реєстрації: 'reports-builder'.
 * Цілі — атрибути data-tour у features/reports/pages/BuilderPage.tsx і builder/editors.tsx.
 */
export const REPORTS_BUILDER_TOUR_ID = 'reports-builder';

export const REPORTS_BUILDER_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Конструктор звітів',
  summary: 'Джерело, період, фільтри, групування, агрегати й подання; результат із вашими правами, збереження й спільний доступ.',
  missingHint: 'Відкрийте «Звіти й аналітика» → «Конструктор».',
  steps: [
    {
      id: 'source',
      target: 'reports-source',
      title: 'Джерело',
      body: 'Задачі, записи часу, замовлення, ОЕ, платежі, фінанси замовлень, управлінські одиниці, процеси. Список залежить від ваших прав: звіт бачить рівно те, що ви бачите в самому модулі.',
      placement: 'right',
    },
    {
      id: 'period',
      target: 'reports-period',
      title: 'Період',
      body: 'Відносний період («Цей місяць», «Останні 30 днів») рахується від сьогодні — збережений звіт завжди свіжий. Власний — фіксовані дати.',
      placement: 'right',
    },
    {
      id: 'filters',
      target: 'reports-filters',
      title: 'Фільтри',
      body: 'Умови діють разом. «Я» підставляє того, хто відкриває звіт, «від сьогодні» — дату перегляду: один спільний звіт працює для кожного.',
      placement: 'right',
    },
    {
      id: 'grouping',
      target: 'reports-grouping',
      title: 'Групування',
      body: 'До трьох групувань; дати — за днями, тижнями, місяцями, кварталами чи роками. Без групувань звіт показує окремі записи.',
      placement: 'right',
    },
    {
      id: 'aggregates',
      target: 'reports-aggregates',
      title: 'Агрегати',
      body: 'Кількість, сума, середнє, медіана, частка з умовою, відношення двох сум. Назва колонки — людською мовою, ключ потрібен для сортування й графіка.',
      placement: 'right',
    },
    {
      id: 'view',
      target: 'reports-view',
      title: 'Подання',
      body: 'Стовпчики, лінія чи кругова над таблицею. Агрегати різних одиниць стають окремими малими графіками — без другої осі, яка вводить в оману.',
      placement: 'right',
    },
    {
      id: 'result',
      target: 'reports-result',
      title: 'Результат',
      body: 'Оновлюється сам. Якщо звіт містить фінансові поля, а в когось немає доступу до фінансів, сервер прибере ці поля й покаже попередження — дані не розкриваються.',
      placement: 'left',
    },
    {
      id: 'save',
      target: 'reports-save',
      title: 'Зберегти й поділитися',
      body: 'Особистий чи спільний звіт (уся організація, ролі, працівники), CSV для Excel, розсилка за розкладом — зі збережених звітів.',
      placement: 'bottom',
    },
  ],
};
